import * as React from 'react'

function SvgPolishingIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M21 15.5v-2.246a1 1 0 00-.725-.961L7 8.5m0 0H3a1 1 0 00-1 1v8m5-9L4.3 2M12 19H7M5 12h3"
        stroke="currentColor"
        strokeWidth={1.6}
        strokeLinecap="round"
      />
      <circle cx={4} cy={20} r={3} stroke="currentColor" strokeWidth={1.6} />
      <path
        d="M12 19a5 5 0 015-5v0a5 5 0 015 5v1H12v-1zM11 23h12"
        stroke="currentColor"
        strokeWidth={1.6}
      />
    </svg>
  )
}

export default SvgPolishingIcon
